import {
  TOrderCreate,
} from '@/types/order.ts';

const strategy: Record<TOrderCreate['target']['strategy'], string> = {
  weight: 'Hmotnosť',
  quantity: 'Kusy',
};

export default strategy;
